"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import RabbitAgent from "@/components/icons/RabbitAgent";

export default function NotFound() {
    const [countdown, setCountdown] = useState(5);
    const router = useRouter();

    useEffect(() => {
        if (countdown === 0) {
            router.push("/");
            return;
        }

        const timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [countdown, router]);

    return (
        <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background to-muted">
            <div className="max-w-md space-y-8 p-8 text-center">
                {/* 404 with rabbit icon */}
                <div className="flex justify-center">
                    <div className="relative">
                        <div className="select-none text-[120px] font-bold text-primary/10">404</div>
                        <RabbitAgent
                            size={64}
                            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-primary"
                        />
                    </div>
                </div>

                {/* Error message */}
                <div className="space-y-2">
                    <h1 className="text-3xl font-bold tracking-tight text-foreground">Page Not Found</h1>
                    <p className="text-muted-foreground">
                        Sorry, we couldn&apos;t find the page you&apos;re looking for. It might have been moved or
                        deleted.
                    </p>
                    <p className="mt-4 text-sm text-muted-foreground">
                        Redirecting to home in <span className="font-bold text-primary">{countdown}</span> second
                        {countdown !== 1 ? "s" : ""}...
                    </p>
                </div>

                {/* Actions */}
                <div className="flex flex-col justify-center gap-3 sm:flex-row">
                    <Link href="/">
                        <Button className="w-full sm:w-auto">Back to Home</Button>
                    </Link>
                    <Button variant="outline" onClick={() => window.history.back()} className="w-full sm:w-auto">
                        Go Back
                    </Button>
                </div>

                {/* Divider */}
                <div className="border-t pt-8">
                    <p className="text-sm text-muted-foreground">
                        Need help? Contact support or check our documentation.
                    </p>
                </div>
            </div>
        </div>
    );
}
